<template>
  <div class="download-page"  v-wechat-title="this.title">
    <div class="mainPage">

      <div class="liveMsg">
         <div class="liveImg">
          <img src="../../assets/delkong.png" alt="">
         </div>
         <div class="liveName"> 数据已删除<br/>
下载APP查看更多精彩内容</div>
      </div>
     <div class="downloadStore" @click="downLoad()">
       立即下载
     </div>
      
    </div>
    <div class="loadFooter">
    <div class="Mongolia" v-if="isWechat == '1'">
        <img src="../../assets/toast.png" alt="">
    </div>  
       <!-- <div class="arrow-left">
         <img src="../../assets/left.png" alt="">
         
       </div>
        <div class="arrow-right">
         <img src="../../assets/right.png" alt="">
       </div>
        -->
    </div>
    
  </div>
</template>

<script>
import cbct from '../../../static/js/base.js'
export default {
  name: 'delPage',
  props: {
    msg: String,

  },
  data(){
    return{
     address:'',
     title:'打开下载听见广播APP',
     isWechat:'0'
    }
  },
   methods:{
     downLoad:function(){
        var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        if (isAndroid) {
            var ua = navigator.userAgent.split("(")[1].split(")")[0];
            var phone = [/IPHONE/gi, /huawei/gi, /mi/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi,]
            if (phone[1].test(ua)) {
                window.location.href='https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C100594819?source=appshare&subsource=C100594819';
            } else if (phone[2].test(ua)) {
                window.location.href='http://app.xiaomi.com/detail/760715';
            } else if (phone[3].test(ua)) {
                window.location.href='http://appdetailh5.vivo.com.cn/detail/2418329?source=7';
            } else if (phone[4].test(ua)) {
                window.location.href='http://appdetailh5.vivo.com.cn/detail/2418329?source=7';
            } else {
                var uas = navigator.userAgent.toLowerCase();
                if(uas.match(/MicroMessenger/i)=="micromessenger") {
                   this.isWechat = '1';
                }else{
                    window.location.href = 'http://img001.cbct.cn/package/SFM_M_A_S_cbct.apk';
                }
            }
        }
        if (isIOS) {
            window.location.href='https://itunes.apple.com/cn/app/%E5%90%AC%E8%A7%81%E5%B9%BF%E6%92%AD-%E5%8F%AF%E5%90%AC%E5%8F%AF%E7%9C%8B%E7%9A%84%E5%B9%BF%E6%92%AD%E7%94%B5%E5%8F%B0%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD/id1439524045?mt=8';
        }
     }
  },
  created(){
    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        this.address=cbct.androidDownloadAddress;
    }
    if (isIOS) {
        this.address=cbct.iosDownloadAddress;
    }
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.download-page{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.liveMsg{
  width: 100%;
  text-align: center;
  /* background: darkgoldenrod; */
}
.liveImg{
  width:1.5rem;
  height:1.52rem;
  margin: 4.32rem auto 0.15rem;
}
.liveImg img{
  width: 100%;
  height: 100%;
}
.liveName{
  /* width:1.19rem; */
  height: 0.29rem;
  font-size:0.28rem;
  /* font-family:PingFangSC-Regular; */
  font-weight:400;
 color:rgba(0,0,0,0.3);
  line-height:0.4rem;
  margin: auto;
  /* background: darkcyan; */
}
.downloadStore{
    width:4.4rem;
    height:0.8rem;
    margin: auto;
    margin-top: 1rem;
    background:rgba(252,64,74,1);
    border-radius:.4rem;
    text-align: center;
    line-height: .8rem;
    font-size: .28rem;
    color: #fff;
  
}
.loadFooter{
  width: 100%;
  height:1rem;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  box-shadow: 0.02rem 0 0.08rem rgba(221, 221,221,.6);
} 
.arrow-left{
  position: absolute;
  left:2.49rem;
  border: solid 1px;
}
.arrow-left>img,.arrow-right>img{ 
 width: 0.22rem;
 height: 0.38rem;
}
.arrow-right{
  position: absolute;
  right:2.57rem;
  border: solid 1px;
 
}
.Mongolia{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.7);
    z-index: 100;
}
.Mongolia img{
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    left: 1.3rem;
    width: 4.9rem;
}



</style>
